let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6osB7")).then(() => parcelRequire('gpOYK'));